module.exports = {
	"ha": "vcha",
	"id": 5.3,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2018 Q1",
		"lastYear": "2018",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 90,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by Age Category, Year Ending 2018 Q1 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 68.22429906542055,
						"dataLabels": {
							"enabled": true,
							"format": "146",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 59.813084112149525,
						"dataLabels": {
							"enabled": true,
							"format": "128",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 57.476635514018696,
						"dataLabels": {
							"enabled": true,
							"format": "123",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 52.80373831775701,
						"dataLabels": {
							"enabled": true,
							"format": "113",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 46.728971962616825,
						"dataLabels": {
							"enabled": true,
							"format": "100",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96.85157421289355,
						"dataLabels": {
							"enabled": true,
							"format": "646",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.50824587706147,
						"dataLabels": {
							"enabled": true,
							"format": "557",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.41079460269866,
						"dataLabels": {
							"enabled": true,
							"format": "523",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 70.16491754122939,
						"dataLabels": {
							"enabled": true,
							"format": "468",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 60.71964017991005,
						"dataLabels": {
							"enabled": true,
							"format": "405",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 97.47747747747748,
						"dataLabels": {
							"enabled": true,
							"format": "1082",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.87387387387388,
						"dataLabels": {
							"enabled": true,
							"format": "931",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.45945945945945,
						"dataLabels": {
							"enabled": true,
							"format": "882",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 72.61261261261261,
						"dataLabels": {
							"enabled": true,
							"format": "806",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 60.54054054054055,
						"dataLabels": {
							"enabled": true,
							"format": "672",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.96516040013798,
						"dataLabels": {
							"enabled": true,
							"format": "2869",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 87.82338737495688,
						"dataLabels": {
							"enabled": true,
							"format": "2546",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.61538461538461,
						"dataLabels": {
							"enabled": true,
							"format": "2453",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.26905829596413,
						"dataLabels": {
							"enabled": true,
							"format": "2327",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 71.40393239047947,
						"dataLabels": {
							"enabled": true,
							"format": "2070",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -31.775700934579444,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.328767123287676,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.90625,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.130081300813007,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.504424778761058,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -3.148425787106446,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.777089783281738,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.104129263913826,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.516252390057357,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.461538461538458,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -2.522522522522519,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.955637707948243,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.616780045351469,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.625310173697272,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.0348395998620252,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.258278145695366,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.652788688138253,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.136567468406028,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.044262999570265,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=214"
			},
			{
				"x": 9,
				"text": "30–39<br>n=667"
			},
			{
				"x": 15,
				"text": "40–49<br>n=1110"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=2899"
			}
		],
		"dataTable": {
			"< 30": [
				214,
				146,
				128,
				123,
				113,
				100
			],
			"30–39": [
				667,
				646,
				557,
				523,
				468,
				405
			],
			"40–49": [
				1110,
				1082,
				931,
				882,
				806,
				672
			],
			"≥ 50": [
				2899,
				2869,
				2546,
				2453,
				2327,
				2070
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_3.json
// module id = 298
// module chunks = 0